module.exports = __webpack_public_path__ + "media/images/cesta-daf1616b1a9c79caf857f4ae75bfa518.png";